import { boot } from '@dazn/bootstrap-lib';

export const getBrandName = () => {
    //check for query params - Hack till the time kayo domains are not ready
    const params = new URLSearchParams(window.location.search);
    const brandFromQuery = params.get('brand');
    if (
        brandFromQuery &&
        boot.brand.allowedBrandNames.includes(
            brandFromQuery.toLowerCase() as boot.brand.BrandName,
        )
    ) {
        return brandFromQuery.toLowerCase() as boot.brand.BrandName;
    }

    //Actual logic - if no query params, check the host
    const urlHost = window.location.host;
    if (urlHost.includes('kayo')) return 'kayo';
    if (urlHost.includes('binge')) return 'binge';
    if (urlHost.includes('foxtel')) return 'foxtelgnc';
    if (urlHost.includes('foxsports')) return 'foxsports';
    return 'dazn';
};
